export class PanelState {
  public pinned = true;
  public height = -1;
}
